/* @flow */
/* eslint no-unused-vars: 0 */

import React from "react"

class ProductsSearchTitle extends React.PureComponent {
  render() {
    const { assets, marketingText, mode, search, title } = this.props;

    if (mode === 'search') {
      return (
        <div className="product-listings-title">
          <h1>
            <img src={assets.icons.search} />
            Search Results for
            <span>&#x27;{this.props.q}&#x27;</span>
          </h1>
        </div>
      );
    }

    return (
      <div className="product-listings-title">
        <h1>
          {mode === 'brand' ? 'Showing products by ' : ''}
          {title}
        </h1>
        {marketingText && (
          <p className="product-listings-title__seo-text">{marketingText}</p>
        )}
      </div>
    );
  }
}

export default ProductsSearchTitle;
